import React, { Component } from "react";
import DropzoneComponent from "react-dropzone-component";

import { storage } from "../../../helpers/Firebase";

const ReactDOMServer = require("react-dom/server");

const dropzoneComponentConfig = {
  postUrl: "no-url",
};

const dropzoneConfig = {
  thumbnailHeight: 160,
  uploadMultiple: true,
  autoProcessQueue: false,
  previewTemplate: ReactDOMServer.renderToStaticMarkup(
    <div className="dz-preview dz-file-preview mb-3">
      <div className="d-flex flex-row ">
        <div className="p-0 w-30 position-relative">
          <div className="dz-error-mark">
            <span>
              <i />
            </span>
          </div>
          <div className="dz-success-mark">
            <span>
              <i />
            </span>
          </div>
          <div className="preview-container">
            <img data-dz-thumbnail className="img-thumbnail border-0" />
            <i className="fa fa-file preview-icon" />
          </div>
        </div>
        <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
          <div>
            <span data-dz-name />
          </div>
          <div className="text-primary text-extra-small" data-dz-size />
          <div className="dz-progress">
            <span className="dz-upload" data-dz-uploadprogress />
          </div>
          <div className="dz-error-message">
            <span data-dz-errormessage />
          </div>
        </div>
      </div>
      <a href="#/" className="remove" data-dz-remove>
        <i className="glyph-icon fa fa-trash" />
      </a>
    </div>
  ),
};

class Images extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getFileFromURL = async (url, callback) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.onload = () => {
      callback(xhr.response);
    };
    xhr.open("GET", url);
    xhr.send();
  };

  addDefault = async () => {
    const { value } = this.props;

    if (value) {
      value.forEach(async (val, index) => {
        await this.getFileFromURL(val, (fileToAdd) =>
          this.afterFileGotten(fileToAdd, val, index)
        );
      });
    }
  };

  afterFileGotten = (blobToAdd, val, index) => {
    const file = new File([blobToAdd], `image_${index}`, {
      type: "image",
    });

    // Object.defineProperty(file, "File_ID", {
    //   value: val.ID,
    //   writable: false,
    // });

    this.blobToDataURL(blobToAdd, (dataURL) =>
      this.afterConvertedToDataURL(file, dataURL, val)
    );
  };

  blobToDataURL = (blob, callback) => {
    const fileReader = new FileReader();
    fileReader.onload = (e) => callback(e.target.result);
    fileReader.readAsDataURL(blob);
  };

  afterConvertedToDataURL = (file, dataURL, val) => {
    const fileToAdd = file;
    fileToAdd.dataURL = val;
    fileToAdd.accepted = true;

    this.dropzone.options.addedfile.call(this.dropzone, fileToAdd);
    this.dropzone.options.thumbnail.call(this.dropzone, fileToAdd, dataURL);
    this.dropzone.options.success.call(this.dropzone, file);
    this.dropzone.options.complete.call(this.dropzone, fileToAdd);
  };

  clear() {
    this.dropzone.removeAllFiles(true);
  }

  render() {
    const { refURL, addImage, removeImage } = this.props;

    const ref = storage.ref(refURL);

    return (
      <>
        <DropzoneComponent
          config={dropzoneComponentConfig}
          djsConfig={dropzoneConfig}
          isMulti
          eventHandlers={{
            init: (dropzone) => {
              this.dropzone = dropzone;
              this.addDefault();
            },
            addedfile: (file) => {
              const timeStamp = Date.now();

              const imageRef = ref.child(`${timeStamp}`);

              imageRef.put(file).then(
                async () => {
                  const uploadURL = await imageRef.getDownloadURL();

                  addImage(uploadURL);

                  this.dropzone.options.success.call(this.dropzone, file);
                  this.dropzone.options.complete.call(this.dropzone, file);

                  this.dropzone.files.forEach((f) => {
                    if (f.upload.uuid === file.upload.uuid) {
                      f.dataURL = uploadURL;
                    }
                  });
                },
                (e) => {
                  console.log("ERROR", e);
                }
              );
            },
            removedfile: async (file) => {
              removeImage(file.dataURL);
            },
          }}
        />
      </>
    );
  }
}

export default Images;
